const STABLE_RECOVERY_DURATION_MS = 30_000

export function wasStable(since: number | undefined): boolean {
  return since !== undefined && performance.now() - since >= STABLE_RECOVERY_DURATION_MS
}

export function retryDelay(attempt: number): number {
  const cap = Math.min(1_000 * 2 ** attempt, 30_000)
  return 300 + Math.random() * Math.max(cap, 3_000)
}

export function scheduleRetry(callback: () => void, delay: number): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined
  const cancel = () => {
    window.removeEventListener('online', done)
    window.removeEventListener('offline', pause)
    clearTimeout(timer)
  }
  const done = () => {
    cancel()
    callback()
  }
  const pause = () => clearTimeout(timer)
  if (window.navigator.onLine !== false) {
    timer = setTimeout(done, delay)
  }
  window.addEventListener('online', done)
  window.addEventListener('offline', pause)
  return cancel
}
